<template>
  <div class="pwa-more">
    <!-- 헤더 -->
    <div class="more-header">
      <span class="page-title">더보기</span>
    </div>

    <!-- 프로필 카드 -->
    <div class="profile-card" @click="goToUserInfo">
      <div class="profile-avatar">
        {{ userInfo?.m_name?.charAt(0) || userInfo?.m_user_name?.charAt(0) || '?' }}
      </div>
      <div class="profile-info">
        <span class="profile-name">{{ userInfo?.m_name || userInfo?.m_user_name || '사용자' }}</span>
        <span class="profile-role">센터장</span>
      </div>
      <v-icon size="20" color="#ccc">mdi-chevron-right</v-icon>
    </div>

    <!-- 센터 정보 -->
    <div class="center-info-card">
      <div class="center-icon">
        <v-icon size="24" color="#1e3a8a">mdi-domain</v-icon>
      </div>
      <div class="center-details">
        <span class="center-name">{{ userInfo?.m_sisul_name || '센터' }}</span>
        <span class="center-code">{{ userInfo?.m_sisul_code || '-' }}</span>
      </div>
    </div>

    <!-- 메뉴 그룹 -->
    <div class="menu-section">
      <!-- 보고서 -->
      <div class="menu-group">
        <span class="group-title">보고서</span>
        <div class="menu-list">
          <router-link to="/pwa/report" class="menu-item">
            <div class="menu-icon purple">
              <v-icon size="18" color="white">mdi-file-chart</v-icon>
            </div>
            <span class="menu-label">보고서 생성</span>
            <v-icon size="18" color="#ddd">mdi-chevron-right</v-icon>
          </router-link>
        </div>
      </div>

      <!-- 알림 -->
      <div class="menu-group">
        <span class="group-title">알림</span>
        <div class="menu-list">
          <router-link to="/pwa/notice" class="menu-item">
            <div class="menu-icon orange">
              <v-icon size="18" color="white">mdi-bell</v-icon>
            </div>
            <span class="menu-label">공지사항</span>
            <v-icon size="18" color="#ddd">mdi-chevron-right</v-icon>
          </router-link>
        </div>
      </div>

      <!-- 설정 -->
      <div class="menu-group">
        <span class="group-title">설정</span>
        <div class="menu-list">
          <router-link to="/pwa/userinfo" class="menu-item">
            <div class="menu-icon blue">
              <v-icon size="18" color="white">mdi-account-cog</v-icon>
            </div>
            <span class="menu-label">내 정보 수정</span>
            <v-icon size="18" color="#ddd">mdi-chevron-right</v-icon>
          </router-link>
          <div class="menu-item" @click="handleInquiry">
            <div class="menu-icon gray">
              <v-icon size="18" color="white">mdi-headset</v-icon>
            </div>
            <span class="menu-label">고객센터</span>
            <span class="menu-sub">070-1234-5678</span>
          </div>
        </div>
      </div>

      <!-- 로그아웃 -->
      <div class="menu-group">
        <div class="menu-list">
          <div class="menu-item logout" @click="handleLogout">
            <div class="menu-icon red">
              <v-icon size="18" color="white">mdi-logout</v-icon>
            </div>
            <span class="menu-label danger">로그아웃</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 앱 정보 -->
    <div class="app-info">
      <span class="app-name">CAION</span>
      <span class="app-version">v1.0.0</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const userInfo = computed(() => store.state.user);

const goToUserInfo = () => router.push('/pwa/userinfo');

const handleInquiry = () => {
  window.location.href = 'tel:070-1234-5678';
};

const handleLogout = async () => {
  try {
    await store.dispatch('pwa/performPwaLogout');
  } catch (error) {
    console.error('로그아웃 오류:', error);
    store.commit('pwa/clearPwaUser');
  }
  router.push('/pwa/login');
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/fonts.scss';

.pwa-more {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px));
  font-family: $Noto_Sans_KR !important;
  * { font-family: $Noto_Sans_KR !important; }

  .more-header {
    background: #fff;
    padding: 16px;
    padding-top: calc(16px + env(safe-area-inset-top, 0px));

    .page-title { font-size: 22px; font-weight: 700; }
  }

  // 프로필 카드
  .profile-card {
    display: flex;
    align-items: center;
    gap: 14px;
    margin: 12px;
    padding: 16px;
    background: #fff;
    border-radius: 12px;
    cursor: pointer;

    &:active { background: #fafafa; }

    .profile-avatar {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      background: linear-gradient(135deg, #1e3a8a, #3b82f6);
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .profile-info {
      flex: 1;

      .profile-name {
        display: block;
        font-size: 17px;
        font-weight: 700;
        color: #111;
      }

      .profile-role {
        display: block;
        font-size: 13px;
        color: #888;
        margin-top: 2px;
      }
    }
  }

  // 센터 정보
  .center-info-card {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0 12px 16px;
    padding: 14px;
    background: #f0f4ff;
    border-radius: 10px;

    .center-icon {
      width: 44px;
      height: 44px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .center-details {
      .center-name {
        display: block;
        font-size: 15px;
        font-weight: 600;
        color: #1e3a8a;
      }

      .center-code {
        display: block;
        font-size: 12px;
        color: #6b7280;
        margin-top: 2px;
      }
    }
  }

  // 메뉴 섹션
  .menu-section {
    padding: 0 12px;
  }

  .menu-group {
    margin-bottom: 16px;

    .group-title {
      display: block;
      font-size: 12px;
      font-weight: 600;
      color: #999;
      margin-bottom: 6px;
      padding-left: 4px;
    }

    .menu-list {
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
    }
  }

  .menu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    text-decoration: none;
    color: inherit;
    border-bottom: 1px solid #f5f5f5;
    cursor: pointer;

    &:last-child { border-bottom: none; }
    &:active { background: #fafafa; }

    .menu-icon {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.purple { background: linear-gradient(135deg, #7c3aed, #a78bfa); }
      &.orange { background: linear-gradient(135deg, #ea580c, #f97316); }
      &.blue { background: linear-gradient(135deg, #0284c7, #38bdf8); }
      &.gray { background: linear-gradient(135deg, #64748b, #94a3b8); }
      &.red { background: linear-gradient(135deg, #dc2626, #f87171); }
    }

    .menu-label {
      flex: 1;
      font-size: 15px;
      font-weight: 500;
      color: #333;

      &.danger { color: #dc2626; }
    }

    .menu-sub {
      font-size: 13px;
      color: #1e3a8a;
      font-weight: 500;
    }
  }

  // 앱 정보
  .app-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    gap: 2px;

    .app-name {
      font-size: 14px;
      font-weight: 600;
      color: #999;
    }

    .app-version {
      font-size: 12px;
      color: #ccc;
    }
  }
}
</style>
